/**
 * Track Application Interaction Event
 */

import { logDebug, pushToAdobeDataLayer } from './utils';

export interface ApplicationInteractionParams {
    /** Action performed (required) */
    action: string;
    /** Step name (required) */
    stepName: string;
    /** Step number (optional) */
    stepNumber?: string;
    /** Selected options (optional) */
    selectedOptions?: Array<{ attribute: string; value: string }>;
}

export const trackApplicationInteraction = ({ action, stepName, stepNumber, selectedOptions }: ApplicationInteractionParams): void => {
    logDebug('Tracking application interaction...');
    const payload = {
        event: 'applicationInteraction',
        _volvo: {
            universal: {
                web: {
                    application: {
                        name: "Product Center",
                        stepNumber: stepNumber,
                        stepName: stepName,
                        action: action,
                        selectedOptions: selectedOptions,
                        applicationInteraction: {
                            value: 1,
                        },
                    },
                },
            },
        },
        web: {
            webInteraction: {
                type: 'other',
            },
        },
    };
    void pushToAdobeDataLayer(payload);
};
